module.exports = __webpack_public_path__ + "static/media/gd.219a06e9.svg";